import React from 'react';
import Card from './LrCard';
import type { CardProps } from './Card.types';

import { useAuthContext } from '../AuthProvider';

const IS_SIGNAL_3 = process.env.SITE === 'IAS-KB-SIGNAL3-SITE';

const WrappedCard = ({ actions: initialActions, ...props }: CardProps) => {
  const { authenticated, initializing, apps } = useAuthContext();

  if (IS_SIGNAL_3 && (!authenticated || initializing)) {
    return null;
  }

  let actions = [];
  if (IS_SIGNAL_3) {
    // @ts-ignore
    actions =
      initialActions?.filter((action: any) => {
        return action.requiredRoles?.filter((role: string) => apps?.includes(role)).length > 0;
      }) ?? [];
  } else {
    // @ts-ignore
    actions = initialActions;
  }

  return (
    <Card
      {...props}
      actions={actions}
      sx={{
        ...(props.variant === 'links list' && {
          '& [class*="Text-root"]': {
            '& ::after': {
              display: 'none'
            },
            '& a': {
              marginLeft: '0',
            },
            '[class*="MuiTypography-body1"] > [class*="MuiLink-root"]': {
              color: 'black'
            }
          }
        })
      }}
    />
  );
};

export default WrappedCard;
